import I18n from 'I18n';
import { CollapsiblePanel } from './CollapsiblePanel';
import { InboxNavPanelBody } from './InboxNavPanelBody';
import { usePortalData } from '../data/usePortalData';
import { DEFAULT_LIMIT, useTicketListings } from '../data/useTicketListings';
import { useTicketListingsSortAndFilters } from '../hooks/useTicketListingsSortAndFilters';
import { jsx as _jsx } from "react/jsx-runtime";
export function InboxNavPanel() {
  var _portalData$settings;
  const {
    data: portalData
  } = usePortalData();
  const {
    ticketView,
    statusFilter,
    searchString,
    sort,
    offset,
    createDateFilter,
    lastActivityFilter
  } = useTicketListingsSortAndFilters();
  const {
    data: tickets,
    loading
  } = useTicketListings({
    offset,
    limit: DEFAULT_LIMIT,
    ticketView,
    statusFilter,
    searchString,
    sort,
    createDateFilter,
    lastActivityFilter
  });
  const title = (portalData === null || portalData === void 0 || (_portalData$settings = portalData.settings) === null || _portalData$settings === void 0 ? void 0 : _portalData$settings.ticketLabelOverride) || I18n.text('customer-portal-app.inboxNavPanel.title');
  return /*#__PURE__*/_jsx(CollapsiblePanel, {
    mode: "sidebar",
    borderSide: "end",
    expandAriaLabel: I18n.text('customer-portal-app.panel.expandTooltip'),
    collapseAriaLabel: I18n.text('customer-portal-app.panel.collapseTooltip'),
    title: title,
    flushBody: true,
    children: /*#__PURE__*/_jsx(InboxNavPanelBody, {
      tickets: tickets,
      loading: loading
    })
  });
}